import { useCallback } from "react";

import firebase from "firebase/app";

import { useBlockingProgress } from "../components/blocking-progress";
import { useSnackbar } from "../components/snackbar";
import { LimitReachedItem } from "../cooperation/blocking-progress/LimitReachedItem";
import { FlashMessage } from "./task-response-action.hook";

export type NewTaskResponseData = AcceptTaskData | DeclineTaskData;

interface AcceptTaskData {
    action: "accept";
    gardeningTaskId: string;
    cpr?: string;
}

interface DeclineTaskData {
    action: "decline";
    gardeningTaskId: string;
    reasons: DeclineTaskReason[];
    comment: string | null;
}

export type DeclineTaskReason = "do-not-understand" | "do-not-have-time" | "cannot-perform" | "too-far-away-or-too-small" | "other";

const newTaskResponse: (data: NewTaskResponseData) => Promise<firebase.functions.HttpsCallableResult>
    = firebase.app().functions("europe-west3").httpsCallable("Match-newTaskResponse");

export const useNewTaskResponseAction = (callback?: (action: NewTaskResponseData["action"]) => void) => {
    const { block, flashMessage, unblock } = useBlockingProgress();
    const { openSnackbar } = useSnackbar();

    return useCallback((data: NewTaskResponseData) => {
        block();

        newTaskResponse(data)
            .then((response) => {

                if ( response.data && response.data.type === "flash message" ) {
                    const onFlashMessageSuccess = () => {
                        openSnackbar("success", "Besvarelsen er modtaget");
                        unblock();
                        if ( callback ) callback(data.action);
                    };
    
                    const responseData = response.data as FlashMessage;
                    
                    if ( responseData.message === "limit reached" ) {
                        return flashMessage(<LimitReachedItem cooperationLevel={responseData.cooperationLevel} tasksUntilNextLevel={responseData.tasksUntilNextLevel} />).then(onFlashMessageSuccess);
                    }
                }

                openSnackbar("success", "Besvarelsen er modtaget");
                unblock();
                if ( callback ) callback(data.action);
            })
            .catch(() => {
                openSnackbar("error", "Der skete en fejl. Besvarelsen er ikke blevet modtaget.");
                unblock();
            });

    }, [block, flashMessage, unblock, openSnackbar, callback]);
};
